import { makeStyles } from "@fluentui/react-components";

export const useOpsGenieButtonStyles = makeStyles({
    root: {
        minWidth: "28px"
    }
});
